// [2026-10-28] ADDED — the Logout confirmation, the same dialog as IncBot's (frontend-incbot
// src/component/Common/ActionPopUp.jsx with its .pop-up-cancel / .pop-up-close buttons), so every
// product asks the same way: centred icon, title and question, Cancel and Logout side by side.
// The generic useConfirm dialog (confirm.jsx) stays as it is for Keys and Members; only Logout uses
// this one. Styles are `.pf-logout-*` in platform-theme.css, values measured from IncBot's render.

import { useEffect, useRef } from 'react'
import logoutConfirmIcon from '../../assets/header/logout-confirm-icon.svg'

export function LogoutConfirmDialog({ onCancel, onConfirm }) {
  const cancelRef = useRef(null)

  // Focus starts on Cancel and Escape cancels, as in this app's other confirm dialog.
  useEffect(() => { cancelRef.current?.focus() }, [])
  useEffect(() => {
    const onKey = (event) => { if (event.key === 'Escape') onCancel() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onCancel])

  return (
    <div className="pf-logout-backdrop"
         onClick={(event) => { if (event.target === event.currentTarget) onCancel() }}>
      <div className="pf-logout-box" role="dialog" aria-modal="true" aria-labelledby="pf-logout-title">
        <img className="pf-logout-icon" src={logoutConfirmIcon} alt="" aria-hidden="true" />
        <h2 id="pf-logout-title" className="pf-logout-title">Logout</h2>
        <p className="pf-logout-text">Are you sure you want to logout?</p>
        <div className="pf-logout-buttons">
          <button type="button" ref={cancelRef} className="pf-logout-cancel" onClick={onCancel}>Cancel</button>
          <button type="button" className="pf-logout-confirm" onClick={onConfirm}>Logout</button>
        </div>
      </div>
    </div>
  )
}
